import { animate, animateChild, group, query, style, transition } from '@angular/animations';

export const dialogBottomOuter = [
  transition(':enter', [
    style({
      'max-height': 0,
    }),
    group([query('*', animateChild()), animate('.25s ease', style({ 'max-height': 110 + 'px' }))]),
  ]),
  transition(':leave', [
    style({
      'max-height': 110 + 'px',
    }),
    group([query('*', animateChild()), animate('.25s ease', style({ 'max-height': 0 }))]),
  ]),
];

export const dialogBottomInner = [
  transition(':enter', [
    style({
      transform: 'scale(0.9)',
      'transform-origin': 'top',
      opacity: 0,
    }),
    animate('0.4s 0.1s cubic-bezier(0.25, 1, 0.5, 1)', style({ transform: 'scale(1)', opacity: 1 })),
  ]),
  transition(':leave', [
    style({
      transform: 'scale(1)',
      'transform-origin': 'top',
      opacity: 1,
    }),
    animate('0.2s cubic-bezier(0.25, 1, 0.5, 1)', style({ transform: 'scale(0.9)', opacity: 0 })),
  ]),
];
